import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  Stack,
  Typography,
} from '@mui/material';

const IMAGE_PATTERN = /^image\//i;
const PDF_PATTERN = /pdf$/i;

export const isPreviewableFile = (mimeType = '', fileName = '') => {
  const normalizedMimeType = String(mimeType || '').toLowerCase();
  const normalizedFileName = String(fileName || '').toLowerCase();
  return IMAGE_PATTERN.test(normalizedMimeType) || normalizedMimeType === 'application/pdf' || PDF_PATTERN.test(normalizedFileName);
};

const FilePreviewDialog = ({
  open,
  title,
  fileName,
  mimeType,
  downloadUrl,
  onClose,
}) => {
  const previewable = isPreviewableFile(mimeType, fileName);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Stack spacing={0.5}>
          <Typography variant="h6" fontWeight={700} noWrap>
            {title || fileName || 'File preview'}
          </Typography>
          {(fileName || mimeType) && (
            <Typography variant="caption" color="text.secondary" noWrap>
              {fileName || mimeType}
            </Typography>
          )}
        </Stack>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, bgcolor: 'background.default' }}>
        {previewable ? (
          IMAGE_PATTERN.test(String(mimeType || '').toLowerCase()) ? (
            <Box
              component="img"
              src={downloadUrl || ''}
              alt={fileName || 'Preview'}
              sx={{ width: '100%', maxHeight: '75vh', objectFit: 'contain', display: 'block', bgcolor: 'background.paper' }}
            />
          ) : (
            <Box sx={{ width: '100%', height: { xs: '70vh', md: '75vh' } }}>
              <Box
                component="iframe"
                src={downloadUrl || ''}
                title={fileName || 'Preview'}
                sx={{ width: '100%', height: '100%', border: 0, bgcolor: 'background.paper' }}
              />
            </Box>
          )
        ) : (
          <Box sx={{ p: 4 }}>
            <Typography variant="body1" gutterBottom>
              This file type does not support in-app preview.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Use the download action to open or save the file locally.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2.5, py: 2 }}>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
        {downloadUrl && (
          <Button variant="contained" component="a" href={downloadUrl} target="_blank" rel="noopener noreferrer">
            Download
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default FilePreviewDialog;